import { useSelector } from "react-redux";
import { getSelectedMover } from "@/store/mover/slice";
import { useFormContext } from "react-hook-form";
import {
  FormField,
  FormItem,
  FormLabel,
  FormControl,
  FormDescription,
} from "@/components/ui/form";
import { Switch } from "@/components/ui/switch";
import { Input } from "@/components/ui/input";

export default function Deposit() {
  const mover = useSelector(getSelectedMover);
  const form = useFormContext();

  const handleDepositToggle = (checked: boolean) => {
    if (checked) {
      // Set to mover configuration defaults when enabling
      form.setValue(
        "deposit_amount",
        mover?.mover_configuration?.deposit_amount || 100
      );
    } else {
      // Clear values when disabling
      form.setValue("deposit_amount", 0);
    }
  };

  return (
    <div>
      <FormField
        control={form.control}
        name="collect_deposit"
        render={({ field }) => (
          <>
            <FormItem className="flex flex-row items-center justify-between gap-2">
              <FormLabel className="text-base">Collect Deposit</FormLabel>
              <FormControl>
                <Switch
                  disabled={!mover?.mover_configuration.enabled_for_payments}
                  checked={
                    mover?.mover_configuration.enabled_for_payments
                      ? field.value
                      : false
                  }
                  onCheckedChange={(checked) => {
                    field.onChange(checked);
                    handleDepositToggle(checked);
                  }}
                />
              </FormControl>
            </FormItem>
            <FormDescription className="text-sm text-stone-800 pt-0 mt-0">
              Customer receives a link to pay.
            </FormDescription>
          </>
        )}
      />

      {!mover?.mover_configuration.enabled_for_payments ? (
        <div className="mt-1 text-red-500 text-sm font-medium">
          You need to be setup for payments to collect a deposit. Please email
          us at help@softwareformovers.com.
        </div>
      ) : (
        form.watch("collect_deposit") && (
          <div className="mt-2 flex flex-col gap-2">
            <FormField
              control={form.control}
              name="deposit_amount"
              render={({ field }) => (
                <FormItem>
                  <FormControl>
                    <div className="relative">
                      <span className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-700 text-sm">
                        $
                      </span>
                      <Input
                        type="number"
                        className="pl-6"
                        min={0}
                        {...field}
                        onChange={(e) =>
                          field.onChange(parseInt(e.target.value))
                        }
                        onFocus={(e) => {
                          e.target.select();
                        }}
                      />
                    </div>
                  </FormControl>
                </FormItem>
              )}
            />
          </div>
        )
      )}
    </div>
  );
}
